<template>
    <GrupoLeyendaCheck
    titulo="Propiedades del suelo"
    checkboxType="switch"
    v-model="propiedadesSuelo_expanded"
    >
        <span v-width-control="'40%'"></span>
        <BotonMasInfo v-width-control="'45%'" @click="masInfo"/>
        <label v-width-control="'100%'" class="radio">
            <input type="radio" value="ph" v-model="propiedad_seleccionada">
            <span>pH (0 a 20 cm de profundidad)</span>
        </label>
        <DaiLeyendaMapa
        :para="[
            'propiedadesSuelo_ph',
        ]"
        v-width-control="'100%'"
        :style="{display:propiedad_seleccionada==='ph'? '':'none'}"
        :coropletas-con-checkbox="true"
        />
        <hr class="dai-map-separator thin" />
        <label v-width-control="'60%'" class="radio">
            <input type="radio" value="salinidad" v-model="propiedad_seleccionada">
            <span>Salinidad superficial</span>
        </label>
        <DaiLeyendaMapa
        :para="[
            'propiedadesSuelo_ce',      
        ]"
        v-width-control="'100%'"
        :style="{display:propiedad_seleccionada==='salinidad'? '':'none'}"
        :coropletas-con-checkbox="true"
        />
        <hr class="dai-map-separator thin" />
        <label v-width-control="'60%'" class="radio">
            <input type="radio" value="riesgo" v-model="propiedad_seleccionada">
            <span>Riesgo de erosión eólica</span>
        </label>
        <DaiLeyendaMapa
        :para="[
            'propiedadesSuelo_riesgo',      
        ]"
        v-width-control="'100%'"
        :style="{display:propiedad_seleccionada==='riesgo'? '':'none'}"
        :coropletas-con-checkbox="true"
        />
    </GrupoLeyendaCheck>
</template>

<script>
import GrupoLeyendaCheck from "./utils/GrupoLeyendaCheck.vue";
import BotonMasInfo from "./utils/BotonMasInfo.vue";
import { scrollTo } from "@/components/_utils.js";

export default {
    components:{
        GrupoLeyendaCheck,
        BotonMasInfo,
    },
    methods:{
        quitarTodos() {},
        masInfo() {
            this.$store.commit("mapa/setFichaActiva", "propiedadesSuelo");
            scrollTo(document.querySelector("[data-section='fichas']"),-102);
        },
    },
    computed: {
        propiedadesSuelo_expanded: {
            get() {
                return this.$store.state.mapa.temasExpandidos.propiedadesSuelo;
            },
            set(expandido) {
                this.$store.commit("mapa/setTemasExpandidos", {
                    tema: "propiedadesSuelo",
                    expandido: expandido,
                });
            },
        },
        propiedad_seleccionada:{
            get(){
                return this.$store.state.mapa.propiedadSueloSeleccionado;
            },
            set(propiedad){
                this.$store.commit("mapa/setPropiedadSueloSeleccionado",propiedad)
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.content {
    button.control-flex-grow-0 {
        display: block;
        margin: 5px 0px 5px auto;
    }
}
label.radio{
    font-size: 14px;
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-top: .5em;
}
input[type="radio"]{
    background-color: var(--control-bg-color);
    font-size: inherit;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    border: 1px solid var(--control-color);
    cursor: pointer;
    margin-right: 0.5em;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 1.5em 1.5em;
    flex-grow: 0;
    margin-bottom: 0;
    margin-top: 0;
    margin-left: 0;
    &:checked{
        background-image: url('data:image/svg+xml,<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><circle cx="50" cy="50" r="37"/></svg>');
        background-size: auto;
    }
}

</style>

<style lang="scss">
.legend-list-checks-colors{
    &[data-layer='propiedadesSuelo_ph'],
    &[data-layer='propiedadesSuelo_ce'],
    &[data-layer='propiedadesSuelo_riesgo']{
        //grid-template-columns: repeat(auto-fill,minmax(45px,1fr));
        grid-template-columns: auto;
        grid-auto-flow: column;

        .list-item-check>label{
            flex-direction: column;
            text-align: center;
            .color-square{
                width: 33px;
                margin-right: 0;
                margin-bottom: 5px;
            }
        }
    }
}
</style>